// Hand-rolled UUID wrapper. Per spec/tech-arch.md §4 (file structure
// names `src/lib/id.ts` for "uuid helper") + spec/build-plan.md P-024 row.
//
// **Why a wrapper, not inline `crypto.randomUUID()` calls.** Three or more
// call sites at P-024 (home + template-list + email-list each create new
// records); per the project's "extract on third use" convention the wrapper
// lands now. A single wrapper keeps the call sites clean (`newId()` reads
// at the call site) and gives a single seam for any future changes (e.g.,
// shorter ids for URL-friendliness, or a deterministic generator in tests).
//
// **`crypto.randomUUID()` availability.** Available in modern browsers
// (Chrome 92+, Firefox 95+, Safari 15.4+) and Node 16+ via the global
// `crypto` object. happy-dom's test environment exposes it natively, so
// no polyfill or test mock is needed for V1. If a test needs deterministic
// ids, Vitest's `vi.spyOn(crypto, 'randomUUID')` is the standard pattern.

export function newId(): string {
  return crypto.randomUUID()
}
